import React, { Component } from 'react';
import {
    Label,
    Input,
    FormGroup,
    Col
} from 'reactstrap';
import PropTypes from 'prop-types';
import './PersonalData.css';
import { Utils } from './../../../utils/utils';

import _ from 'lodash';
import { sharedLabelsPath } from "../../../reducers/common/localization";
import Select from '../../commonComponents/customSelect/CustomSelect.container';

export const PROFESSIONAL_FORM_MODE = "PROFESSIONAL_FORM_MODE";
export const PERSONAL_FORM_MODE = "PERSONAL_FORM_MODE";

class PersonalData extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.getFormGroup = this.getFormGroup.bind(this);
    }

    componentWillMount() {
        if (this.props.countryCode && !_.isNil(this.props.continents) && this.props.continents.length !== 0) {
            this.props.setContinentByCountry(this.props.countryCode);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.countryCode && (_.isNil(this.props.continents) || this.props.continents.length === 0) && !_.isNil(nextProps.continents)) {
            this.props.setContinentByCountry(nextProps.countryCode);
        }
    }

    render() {
        return (
            <div className="personal-data-container">
                {this.renderFormGroups()}
            </div>
        );
    }

    handleChangeContinent = (selectedOption) => {
        this.props.onContinentSet(selectedOption.value);
        this.props.handleChangeByValue('countryCode')('');
    };

    getFieldsList() {
        let emailTitle = _.get(this.props.translation, sharedLabelsPath.email_label);

        switch (this.props.mode) {
            case PROFESSIONAL_FORM_MODE:
                emailTitle = _.get(this.props.translation, sharedLabelsPath.professional_email_label);
                break;
        
            case PERSONAL_FORM_MODE:
                emailTitle = _.get(this.props.translation, sharedLabelsPath.personal_email_label);
                break;
        
            default:
                break;
        }
        
        return [
            {
                value: "firstName",
                title: _.get(this.props.translation, sharedLabelsPath.first_name_label),
            },
            {
                value: "lastName",
                title: _.get(this.props.translation, sharedLabelsPath.last_name_label),
            },
            {
                value: "email",
                title: emailTitle,
                type: 'email',
                isDisabled: !this.props.isEmailEditable
            },
            {
                value: "phoneNumber",
                title: _.get(this.props.translation, sharedLabelsPath.phone_number_label),
            },
            {
                value: "continentCode",
                title: _.get(this.props.translation, sharedLabelsPath.continent_filter_label) + '*',
                onChange: this.handleChangeContinent,
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.continents,
                    _.get(this.props.translation, sharedLabelsPath.continents)
                ),
                placeholder: _.get(this.props.translation, sharedLabelsPath.continent_input_placeholder),
                isDisabled: !this.props.continents
            },
            {
                value: "countryCode",
                title: _.get(this.props.translation, sharedLabelsPath.country_label) + '*',
                onChange: this.handleChangeCountry,
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.countries,
                    _.get(this.props.translation, sharedLabelsPath.countries)
                ),
                placeholder:_.get(this.props.translation, sharedLabelsPath.country_input_placeholder),
                isDisabled: !this.props.countries
            }
        ]
    }

    renderFormGroups() {
        return [..._.map(this.getFieldsList(), this.getFormGroup)];
    }

    getFormGroup(params) {
        if (!_.isNil(this.props.fields) && !this.props.fields.includes(params.value)) {
            return;
        }

        if (params.type === 'select') {
            return this.getSelectFormGroup(params);
        }
        if (!params || typeof (params) !== 'object') {
            return;
        }

        let title = params.title + (!_.isNil(this.props.requiredFields) && this.props.requiredFields.includes(params.value) ? "*" : "");
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={3} >{title}</Label>
                <Col sm={9}>
                    <Input type={params.type || 'text'} id={id}
                        value={this.props[params.value]}
                        onChange={params.onChange || this.props.handleChange(params.value)}
                        placeholder={params.title}
                        disabled={params.isDisabled}
                        required={!_.isNil(this.props.requiredFields) ? this.props.requiredFields.includes(params.value) : false}
                    >
                        {params.content}
                    </Input>
                </Col>
            </FormGroup>
        );
    }

    getSelectFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={3}>{params.title + (params.isRequired ? '*' : '')}</Label>
                <Col sm={9}>
                    <Select id={id}
                            selectedOption={_.find(params.content, option => option.value === this.props[params.value])}
                            options={params.content}
                            onSelect={params.onChange}
                            placeholder={params.placeholder}
                            disabled={params.isDisabled}
                            requiredFieldError={this.props.requiredFieldError === params.value}
                    />
                </Col>
            </FormGroup>
        );
    };

    handleChangeCountry = (selectedOption) => {
        this.props.handleChangeByValue('countryCode')(selectedOption.value);
    }
}

PersonalData.propTypes = {
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    mode: PropTypes.string,
    isEmailEditable: PropTypes.bool,
    phoneNumber: PropTypes.string.isRequired,
    continentCode: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    continents: PropTypes.array,
    countries: PropTypes.array,
    requiredFields: PropTypes.array,
    translation: PropTypes.object.isRequired,
    requiredFieldError: PropTypes.string,
    fields: PropTypes.array,
    onContinentSet: PropTypes.func.isRequired,
    setContinentByCountry: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleChangeByValue: PropTypes.func.isRequired
};

export default PersonalData;



// WEBPACK FOOTER //
// ./src/components/accountManagement/personalData/PersonalData.js